import { css, keyframes } from 'goober';
import React from 'react';
import colors from '../../styles/colors';
const HeartBeatAnimation = keyframes `
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(0.8);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;
const HeartBeatContainer = css `
  animation-name: ${HeartBeatAnimation};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  display: flex;
`;
export const HeartBeat = (props) => {
    return React.createElement("div", { className: HeartBeatContainer }, props.children);
};
const HeartBeatWrapper = ({ width = 48, height = 48 }) => css `
  width: ${width}px;
  height: ${height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.heartGradient};
  border-radius: 50%;
`;
export const HeartShell = (props) => {
    return React.createElement("div", { className: HeartBeatWrapper(props) }, props.children);
};
export const HeartIcon = ({ liked, width = 23, height = 20, }) => {
    const fillColor = liked ? colors.glanceRed : colors.white;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 23 20" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { fill: fillColor, fillRule: "nonzero" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M16.18 0c-2.131 0-4.096 1.094-5.14 2.862C9.996 1.094 8.031 0 5.9 0 2.643 0 0 2.876 0 5.977 0 13.766 11.04 19.2 11.04 19.2s11.04-5.434 11.04-13.223c0-3.1-2.642-5.977-5.9-5.977z", transform: "translate(-80 -669) translate(80 669)" }))))));
};
//# sourceMappingURL=index.js.map